import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NzImageModule, NzImageService } from 'ng-zorro-antd/image';
import { environment } from '../../../../environments/environment';
import { SlideRightDirective } from '../../../directives/animations/slide-right.directive';
import { SlideupDirective } from '../../../directives/animations/slideup.directive';

@Component({
  selector: 'section[app-about-team-section]',
  imports: [
    SlideRightDirective,
    SlideupDirective,
    NzImageModule,
    MatIconModule,
    RouterModule,
  ],
  templateUrl: './about-team-section.html',
  styleUrl: './about-team-section.scss',
})
export class AboutTeamSection {
  constructor(private imageService: NzImageService) {}
  get appname(): string {
    return environment.appname;
  }

  viewImage(src: string): void {
    this.imageService.preview([{ src }]);
  }
}
